// src/i18n/unsubscribeTranslations.js
const unsubscribeTranslations = {
  pt: {
    title: "Preferências de E-mail",
    heading: "Cancelar Inscrição",
    content: [
      "Lamentamos ver você partir. Ao confirmar, seu e-mail será removido da nossa lista de novidades e recomendações de leitura do Kito.",
      "Você sempre poderá se inscrever novamente através do nosso aplicativo."
    ],
    button: "Confirmar Cancelamento",
    loading: "Processando...",
    success: {
      heading: "Inscrição Cancelada",
      message: "Seu e-mail foi removido com sucesso. Esperamos ver você de volta em breve!"
    },
    error: "Ocorreu um erro ao processar seu pedido. Por favor, tente novamente."
  },
  en: {
    title: "Email Preferences",
    heading: "Unsubscribe",
    content: [
      "We're sorry to see you go. By confirming, your email will be removed from our Kito news and reading recommendations list.",
      "You can always subscribe again through our app."
    ],
    button: "Confirm Unsubscribe",
    loading: "Processing...",
    success: {
      heading: "Unsubscribed",
      message: "Your email has been successfully removed. We hope to see you back soon!"
    },
    error: "An error occurred while processing your request. Please try again."
  },
  es: {
    title: "Preferencias de Correo",
    heading: "Cancelar Suscripción",
    content: [
      "Lamentamos verte partir. Al confirmar, tu correo será eliminado de nuestra lista de novedades y recomendaciones de lectura de Kito.",
      "Siempre podras volver a suscribirte a través de nossa aplicación."
    ],
    button: "Confirmar Cancelación",
    loading: "Procesando...",
    success: {
      heading: "Suscripción Cancelada",
      message: "Tu correo ha sido eliminado con éxito. ¡Esperamos verte de vuelta pronto!"
    },
    error: "Ocurrió un error ao procesar su pedido. Por favor, inténtelo de nuevo."
  }
};

export default unsubscribeTranslations;